// Generated by CoffeeScript 1.11.1

/**
Generates a Cloudinary image path with unique sizing string in url.

@method resizeImage
@param {String} url the url without sizing string
@param {Number} width new image width
@param {Number} height new image height
@param {String} crop crop mode for image (scale | fit | fill | limit | pad | crop ) http://cloudinary.com/documentation/image_transformations#crop_modes
@return {Object}
 */
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    return define('sp/utilities/resize_image',[], factory);
  } else if (typeof module === 'object' && module.exports) {
    return module.exports = factory();
  } else {
    return root.resizeImage = factory();
  }
})(this, function() {
  var resizeImage;
  return resizeImage = function(url, width, height, crop, format, quality) {
    var reg, sizing, splice;
    if (url && /(http(s?):).+(cloudinary|cloudfront)/.test(url)) {
      splice = function(str, index, count, add) {
        return str.slice(0, index) + (add || "") + str.slice(index + count);
      };
      sizing = [];
      if (width) {
        sizing.push("w_" + width);
      }
      if (height) {
        sizing.push("h_" + height);
      }
      if (crop) {
        sizing.push("c_" + crop);
      }
      if (quality) {
        sizing.push("q_auto:" + quality);
      }
      sizing = sizing.join(",");
      if (['jpg', 'jpeg', 'gif', 'png'].indexOf(format) > -1) {
        url = url.substr(0, url.lastIndexOf(".")) + ("." + format);
      }
      reg = /\/(w|h|c|q)_[^\/]*/g;
      url = url.replace(reg, "");
      if (sizing.length) {
        sizing = sizing + "/";
      }
      return splice(url, url.indexOf("/upload") + 8, 0, sizing).trim();
    } else {
      return url;
    }
  };
});

